import JSEncrypt from 'jsencrypt'

/**
 * RSA加密
 * @param str
 */
export function RSA(str) {
    // 处理非法输入
    if (['', undefined, null].includes(str)) {
        throw new Error('invalid input');
    }
    // 创建加密对象实例
    const encrypt = new JSEncrypt();
    // 公钥
    const publicKey =
        'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCVjqbyQix2fMQVKJGvoIhSt0wUjuZ6bVYtqJIYhFJEZvuKUt16ZotyPeLu/N2bAy8J8rZntyPl6fs9gQi/xlZQr3aHlslehGmWDbI2MmJOj7DOLRAE/4XNjGlN7CVNoaXHehvGeaPxeD+LwpfMCaP/3sqkvDtGWUWw/pBbKS0NLQIDAQAB';
    encrypt.setPublicKey(publicKey);
    return encrypt.encrypt(str); // 对内容进行加密
}
